var React = require('react');

function IcResultComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-result"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M3.75 3.27051L5 2.02051L6.25 3.27051L7.5 2.02051L8.75 3.27051L10 2.02051L11.25 3.27051L12.5 2.02051L13.75 3.27051L15 2.02051L16.25 3.27051L17.25 2.27051V17.7301L16.25 16.7301L15 17.9801L13.75 16.7301L12.5 17.9801L11.25 16.7301L10 17.9801L8.75 16.7301L7.5 17.9801L6.25 16.7301L5 17.9801L3.75 16.7301L2.75 17.7301V2.27051L3.75 3.27051ZM3.91667 3.83362V16.167H16.0833V3.83362H3.91667ZM5.25 13.917V12.7503H14.75V13.917H5.25ZM5.25 10.5836V9.41695H14.75V10.5836H5.25ZM5.25 7.25029V6.08362H14.75V7.25029H5.25Z","fill":"#3E3E3E"})));
}

IcResultComponent.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IcResultComponent;

IcResultComponent.default = IcResultComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/DetailsModalV2/images/ic-result.component.svg
// module id = 285
// module chunks = 0